import React, { useEffect, useState } from "react";
import backgroundimage from "../../assets/bgsize.jpg";

const PaymentModal = ({ fullname, address, handleClickCheckButton }) => {
  const [randomNum, setRandomNum] = useState("");

  //! Order Code Sadece compoenent oluşturulduğunda çalışır
  useEffect(() => {
    setRandomNum(generateRandomNumber());
  }, []);

  //! Create Order Code
  function generateRandomNumber() {
    let randomNumber = "";
    for (let i = 0; i < 10; i++) {
      randomNumber += Math.floor(Math.random() * 10);
    }
    return randomNumber;
  }

  return (
    <div
      style={{
        backgroundImage: `url(${backgroundimage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      className="payment-modal animate__animated animate__fadeIn animate__slower"
    >
      <div className="payment-modal-div">
        <h3 style={{ color: "orangered" }} className="text-uppercase">
          Order Received!
        </h3>

        <h6 className="text-uppercase fw-bold"> Fullname </h6>
        <h6 className="text-capitalize"> {fullname} </h6>
        <h6 className="text-uppercase fw-bold">Address</h6>
        <p className="text-center text-capitalize">{address}</p>
        <h6 style={{ color: "orangered" }}>ORDER CODE: {randomNum} </h6>
        <button
          onClick={handleClickCheckButton}
          className="order-check-btn text-center"
        >
          <i className="fas fa-regular fa-check"></i>
        </button>
      </div>
    </div>
  );
};

export default PaymentModal;
